import { render, staticRenderFns } from "./AskUs.vue?vue&type=template&id=66e043db"
import script from "./AskUs.vue?vue&type=script&lang=js"
export * from "./AskUs.vue?vue&type=script&lang=js"
import style0 from "./AskUs.vue?vue&type=style&index=0&id=66e043db&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports